export enum FeedbackFormFields {
  USER = 'user',
  SUBJECT = 'subject',
  MESSAGE = 'message',
}
